module.exports = __webpack_public_path__ + "static/media/phone_global.f6a9ea8b.svg";